import { ExecutionStatusEnum, graphql } from '@e-socna/data-layer';
import { EMPTY_ARRAY } from '@e-socna/empty';
import type { Id } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionPage_ServiceUsages_PricingPermission_QueryDocument =
  graphql(`
    query MissionPage_ServiceUsages_PricingPermission_Query($id: Id!) {
      findOneMission(id: $id) {
        access {
          can(scope: "updatePricing") {
            details {
              fr
            }
            status
          }
        }
      }
    }
  `);

export type PricingEditionPermission = Readonly<{
  isEditable: boolean;
  reasons: readonly string[];
}>;

const EDITABLE: PricingEditionPermission = {
  isEditable: true,
  reasons: EMPTY_ARRAY,
};

const UNKNOWN_YET: PricingEditionPermission = {
  isEditable: false,
  reasons: EMPTY_ARRAY,
};

// The pricing is written by the users whose rights allow it, unless the state of the quotation
// freezes it (the mission access `updatePricing`).
export const usePricingEditionPermission = (
  missionId: Id,
): PricingEditionPermission => {
  const { data } = useGraphQLQuery(
    MissionPage_ServiceUsages_PricingPermission_QueryDocument,
    { id: missionId },
  );

  const permission = data?.findOneMission.access.can;

  if (!permission) {
    return UNKNOWN_YET;
  }

  return permission.status === ExecutionStatusEnum.Ok
    ? EDITABLE
    : {
        isEditable: false,
        reasons: permission.details.map(({ fr }) => fr),
      };
};
